module.exports = __webpack_public_path__ + "12375c3bd6c89e9b794fedd9e58ba65b.png";